module.exports = __webpack_public_path__ + "static/media/B&TScreenshot1.d179ce5d.png";